module.exports = __webpack_public_path__ + "static/media/door_grey.3bf77b1c.jpg";